import React from "react";
import styled from "styled-components";
import { PADDING_BY_SIZE, getBGColorByVariant, getTextColorByVariant } from "./utils";
const BadgeContainer = styled.div`
  padding: ${({ $size }) => PADDING_BY_SIZE[$size].topBottom} ${({ $size }) => PADDING_BY_SIZE[$size].leftRight};
  background-color: ${({ theme, $variant, $solid }) => getBGColorByVariant(theme, $variant, $solid)};
  border-radius: ${({ theme }) => theme.spacings.xl};
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: ${({ $width }) => $width || "auto"};
`;
const BadgeText = styled.small`
  text-transform: uppercase;
  color: ${({ theme, $variant, $solid }) => getTextColorByVariant(theme, $variant, $solid)};
  text-align: center;
  font-weight: ${({ $size }) => $size === "xs" ? "normal" : "bold"};
  font-size: ${({ theme, $size }) => $size === "xs" ? "0.65rem" : theme.fonts.size.small};
  line-height: normal;
`;
function Badge({
  children = void 0,
  variant = "default",
  size = "sm",
  solid = false,
  empty = false,
  title = void 0
}) {
  if (!children && typeof children !== "number" && !empty) return null;
  return /* @__PURE__ */ React.createElement(
    BadgeContainer,
    {
      role: "status",
      title,
      "aria-label": children == null ? void 0 : children.toString(),
      $size: size,
      $variant: variant,
      $solid: solid
    },
    /* @__PURE__ */ React.createElement(BadgeText, { $size: size, $variant: variant, $solid: solid }, children)
  );
}
export default Badge;
